import { goRequest } from '../utils/httpClientTs';
import {
  SPDPreworkForm,
  SPDPreworkListItem,
  SPDPreworkUpdateRequest,
  ApprovalActionRequest,
  AnnualReportsDashboardResponse,
} from '../types/annualReports';

interface SPDPreworkListResponse {
  forms: SPDPreworkListItem[];
}

export const getSPDPreworkList = async (
  spdChapterId?: string
): Promise<SPDPreworkListResponse> => {
  const params = spdChapterId ? { spd_chapter_id: spdChapterId } : {};
  return goRequest<SPDPreworkListResponse>({
    url: '/api/annual-reports/prework/spd-dues',
    method: 'GET',
    params,
  });
};

export const getSPDPreworkDetail = async (
  id: string
): Promise<SPDPreworkForm> => {
  return goRequest<SPDPreworkForm>({
    url: `/api/annual-reports/prework/spd-dues/${id}`,
    method: 'GET',
  });
};

export const updateSPDPrework = async (
  id: string,
  data: Partial<SPDPreworkUpdateRequest>
): Promise<SPDPreworkForm> => {
  return goRequest<SPDPreworkForm>({
    url: `/api/annual-reports/prework/spd-dues/${id}`,
    method: 'PATCH',
    data,
  });
};

export const approveSPDPrework = async (
  id: string,
  action: 'approve' | 'send_back' | 'unapprove'
): Promise<{ message: string }> => {
  const data: ApprovalActionRequest = { action };
  return goRequest<{ message: string }>({
    url: `/api/annual-reports/prework/spd-dues/${id}/approval`,
    method: 'POST',
    data,
  });
};

export const getDashboard =
  async (): Promise<AnnualReportsDashboardResponse> => {
    return goRequest<AnnualReportsDashboardResponse>({
      url: '/api/annual-reports/dashboard',
      method: 'GET',
    });
  };
